import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import parseISO from 'date-fns/parseISO'
import type { OriginalRootState } from 'redux/rootReducer'
import assetsAPI from 'services/assets'
import { CommonConfig } from 'typings/commonConfig'

const SLICE_NAME = 'configSlice'

export interface ConfigState extends CommonConfig {
  status: 'pending' | 'success' | 'error'
  error?: unknown
}

/** The application fetches immediately, so start in pending state */
export const initialState: ConfigState = {
  status: 'pending'
}

export const fetchCommonConfig = createAsyncThunk(
  `${SLICE_NAME}/fetchCommonConfig`,
  async () => {
    const { error, data } = await assetsAPI.getConfig()

    if (error) {
      throw error
    }
    return data
  }
)

export const configSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCommonConfig.fulfilled, (state, action) => {
        return { status: 'success', ...action.payload }
      })
      .addCase(fetchCommonConfig.rejected, (state, action) => {
        return { status: 'error', error: action.payload }
      })
  }
})

export default configSlice.reducer

export const selectConfig = (state: OriginalRootState): ConfigState => {
  return state.config
}

export const selectShowCoBrowse = createSelector(
  selectConfig,
  ({ status, cobrowseExp }: ConfigState) => {
    if (status === 'pending') {
      return false
    }

    if (cobrowseExp) {
      return parseISO(cobrowseExp).getTime() > Date.now()
    }

    // always show co-browse icon if no co-browse exp is set
    return true
  }
)
